import { render, staticRenderFns } from "./LsFAQ.vue?vue&type=template&id=02b47552&scoped=true&"
import script from "./LsFAQ.vue?vue&type=script&lang=js&"
export * from "./LsFAQ.vue?vue&type=script&lang=js&"
import style0 from "./LsFAQ.vue?vue&type=style&index=0&id=02b47552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b47552",
  null
  
)

export default component.exports